import type {
  SubLocaleDetails,
  SupportedLocale,
  SupportedLocalesOrSubLocale,
  SupportedSubLocale
} from "../config/locales";

import {
  isSubLocaleEquivalentToParent,
  supported_sub_locales
} from "../config/locales";

const sub_locales_map = (
  Object.entries(supported_sub_locales) as [
    SupportedSubLocale,
    SubLocaleDetails
  ][]
).reduce<Map<SupportedLocale, Map<string, SupportedLocalesOrSubLocale>>>(
  (acc, [sub_locale_code, sub_locale]) => {
    if (!acc.has(sub_locale.parent_locale)) {
      acc.set(sub_locale.parent_locale, new Map());
    }

    const locale = isSubLocaleEquivalentToParent(sub_locale_code)
      ? sub_locale.parent_locale
      : sub_locale_code;

    acc
      .get(sub_locale.parent_locale)
      ?.set(sub_locale.country_code2.toLowerCase(), locale);

    return acc;
  },
  new Map()
);

export function getSubLocaleByCountryCode(
  locale: SupportedLocale,
  country_code2: string
): SupportedLocalesOrSubLocale | undefined {
  return sub_locales_map.get(locale)?.get(country_code2.toLowerCase());
}
